import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "./ContactUs.css";
import { ConfigContext } from "../Context/ConfigContext";

function ContactUs() {
  const { phone_no, email, ApiUrl, apiHeaderJson } = useContext(ConfigContext);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    try {
      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        subject: formData.subject.trim(),
        message: formData.message.trim(),
      };

      const response = await axios.post(`${ApiUrl}apis/SendUsMail`, payload, {
        headers: apiHeaderJson,
      });

      const { success, message } = response.data;
      if (success) {
        setSubmitted(true);
        // Optionally show a success toast
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: message || "We'll get back to you soon.",
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message || "Failed to send message. Please try again.",
        });
      }
    } catch (err) {
      console.error("Contact form error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again later.",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="contact-hero">
        <div className="contact-hero-content" data-aos="fade-up">
          <span className="contact-hero-tag">WE'RE HERE TO HELP</span>
          <h1>Contact <span>Us</span></h1>
          <p>Have questions, feedback or suggestions? We'd love to hear from you.</p>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="contact-cards-section">
        <div className="contact-cards-container">
          <div className="contact-info-card" data-aos="fade-up">
            <div className="contact-info-icon"><i className="ri-map-pin-line"></i></div>
            <h3>Our Address</h3>
            <p>Royal Bakery<br />Industrial Zone, Behind Gining Factory,<br /> Old Baijipura , Chh.Sambhajinagar(Aurangabad) - 431001 (MS) INDIA.</p>
          </div>

          <div className="contact-info-card" data-aos="fade-up" data-aos-delay="150">
            <div className="contact-info-icon"><i className="ri-phone-line"></i></div>
            <h3>Phone</h3>
            <p>
              <a href={`tel:${phone_no}`} target="_blank" className="text-decoration-none text-dark" rel="noopener noreferrer">
                {phone_no}
              </a>
            </p>
          </div>

          <div className="contact-info-card" data-aos="fade-up" data-aos-delay="300">
            <div className="contact-info-icon"><i className="ri-mail-line"></i></div>
            <h3>Email</h3>
            <p>
              <a href={`mailto:${email}`} target="_blank" className="text-decoration-none text-dark" rel="noopener noreferrer">
                {email}
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Form + Map */}
      <section className="contact-section">
        <div className="contact-container">
          {/* Form */}
          <div className="contact-form-card" data-aos="fade-right">
            {submitted ? (
              <div className="contact-success">
                <i className="ri-checkbox-circle-fill"></i>
                <h2>Message Sent!</h2>
                <p>Thank you, {formData.name || "friend"}! We've received your message and will get back to you soon.</p>
                <button
                  className="contact-another-btn"
                  onClick={() => {
                    setSubmitted(false);
                    setFormData({ name: "", email: "", subject: "", message: "" });
                  }}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h2>Send Us a Message</h2>
                <p className="contact-form-subtitle">We typically respond within 24 hours</p>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="c-name">Full Name *</label>
                    <input
                      type="text"
                      id="c-name"
                      name="name"
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="c-email">Email Address *</label>
                    <input
                      type="email"
                      id="c-email"
                      name="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="c-subject">Subject *</label>
                  <input
                    type="text"
                    id="c-subject"
                    name="subject"
                    placeholder="What is this about?"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="c-message">Message *</label>
                  <textarea
                    id="c-message"
                    name="message"
                    rows="6"
                    placeholder="Write your message here..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="contact-submit-btn" disabled={submitLoading}>
                  {submitLoading ? (
                    <>
                      <i className="ri-loader-4-line spin"></i> Sending...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-fill"></i> Send Message
                    </>
                  )}
                </button>
              </form>
            )}
          </div>

          {/* Quick Help */}
          <div className="contact-side" data-aos="fade-left">
            <div className="contact-faq-card">
              <h3>Quick Help</h3>
              <div className="contact-faq-item">
                <h4><i className="ri-question-line"></i> Looking for bulk orders?</h4>
                <p>Visit our <Link to="/inquiry">Inquiry page</Link> and our team will assist you.</p>
              </div>
              <div className="contact-faq-item">
                <h4><i className="ri-question-line"></i> Want to explore products?</h4>
                <p>Check out our <Link to="/products">Products page</Link> for the full range.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactUs;